import { Zap } from "lucide-react";

export const LIMITED_NOTE = "First come, first served (OT8 still takes a whole set first). Claims are pending until their set meets the fill rule; sets that don't meet it when claims close are dropped.";
export const LIMITED_UNIT_NOTE = "First come, first served. Every set must be 4/4 to go through; full sets can be collected early, and sets that aren't 4/4 when claims close are dropped.";

export const LimitedTag = ({ testId }) => (
  <span data-testid={testId} title={LIMITED_NOTE} className="inline-flex items-center gap-1 text-xs rounded-full bg-red-500/15 text-red-200 px-2 py-0.5 font-semibold">
    <Zap className="h-3 w-3" />Limited
  </span>
);
